import { createRouter, createWebHashHistory } from 'vue-router'
import Login from "../views/Login.vue";
import MainBox from "../views/MainBox.vue";
import RoutersConfig from './config';
import store from "../store/index";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/mainBox",
    name: "mainBox",
    component: MainBox
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),// 切换到新页面时，滚动到顶部和最左侧
})
router.beforeEach((to, form, next) => {
  if (to.name == "login") {
    next();
  } else {
    // 已授权 next
    // 未授权 返回login页面
    // if (!localStorage.getItem("token")) {
    //   next({ path: "/login" })
    // } else {
    //   if (!store.state.isGetterRouter) {
    //     // 1.移除添加的子路由
    //     router.removeRoute("mainBox");
    //     ConfigRouter();
    //     next({ path: to.fullPath })
    //   } else {
    //     next();
    //   }
    // }
    if (!store.state.isGetterRouter) {
      // 1.移除添加的子路由
      router.removeRoute("mainBox");
      ConfigRouter();
      next({ path: to.fullPath })
    } else {
      next();
    }
  }
})
const ConfigRouter = () => {
  // 2.添加移除的路由
  if (!router.hasRoute("mainBox")) {
    router.addRoute({
      path: "/mainBox",
      name: "mainBox",
      component: MainBox
    })
  }
  RoutersConfig.forEach(item => {
    checkPermisson(item) && router.addRoute("mainBox", item)
  });
  store.commit("changeGetterRouter", true)
}

const checkPermisson = (routerItem) => {
  if (routerItem.requireAdmin) {
    return store.state.userInfo.role == 1
  }
  return true;
}

export default router
